<template>
  <form>
    <v-document-upload-popup
      v-show="uploadDocumentsPopupVisible"
      @close="uploadDocumentsPopupVisible = false"
      @success="addDocuments($event)"
    ></v-document-upload-popup>

    <div class="pill-diemension-special">
      <img src="~@/assets/pill-dimensions-special.svg" />
      <div class="text">
        <h2 class="title">{{ $t("page.pill-shape-form.special-shape.title") }}</h2>
        <p v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </p>
        <p v-if="hasAlreadyReachedSpecialFormLimit" class="error-message">
          {{ $t("page.pill-shape-form.special-shape.limit-error") }}
        </p>
        <p>
          {{ $t("page.pill-shape-form.special-shape.description") }}
        </p>
        <div class="icon-upload" :class="{ grey: hasAlreadyReachedSpecialFormLimit }"></div>
        <div class="text-upload" :class="{ grey: hasAlreadyReachedSpecialFormLimit }">
          <a href="javascript:void(0)" @click="showDocumentsUploadPopups">
            {{
              form.documents && form.documents.length
                ? form.documents.length + " " + $t("page.pill-shape-form.special-shape.uploaded-documents")
                : $t("page.pill-shape-form.special-shape.upload-documents")
            }}
          </a>
        </div>
        <textarea
          v-model="form.additionalInformation"
          class="textarea"
          :placeholder="$t('page.pill-shape-form.special-shape.additional-information.placeholder')"
        ></textarea>
        <v-button primary @click="sendSpecialShapeForm" :disabled="hasAlreadyReachedSpecialFormLimit">
          {{ $t("page.pill-shape-form.save") }}
        </v-button>
      </div>
    </div>
  </form>
</template>

<script>
import VDocumentUploadPopup from "@/components/pills/v-document-upload-popup.vue";
import { mapGetters } from "vuex";
import { convertFileToBase64 } from "@/utils/FileUtils";
import { VButton } from "shared";
import * as PillsDAO from "@/dao/pills-dao";

export default {
  name: "VPillShapeFormSpecialShape",
  components: {
    VButton,
    VDocumentUploadPopup,
  },
  props: {
    pillFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      uploadDocumentsPopupVisible: false,
      form: {
        additionalInformation: this.pillFormData.AdditionalInformation || "",
        documents: this.pillFormData.Documents || [],
      },
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters("workLists", ["currentWorkListId", "currentWorkList"]),
    hasAlreadyReachedSpecialFormLimit() {
      return (
        !this.pillFormData &&
        this.currentWorkList.some(
          (worklistItem) => worklistItem.shapeType === "special" || worklistItem.shapeType === "specialform"
        )
      );
    },
  },
  methods: {
    async addDocuments({ files }) {
      this.form.documents = await Promise.all(
        files.map(async (file) => ({
          name: file.name,
          content: await convertFileToBase64(file),
        }))
      );
    },
    showDocumentsUploadPopups() {
      if (!this.hasAlreadyReachedSpecialFormLimit) {
        this.uploadDocumentsPopupVisible = true;
      }
    },
    async sendSpecialShapeForm() {
      try {
        const pillAdditionalData = {
          AdditionalInformation: this.form.additionalInformation,
          Documents:
            this.form.documents && this.form.documents.length
              ? this.form.documents.map((doc) => ({ Name: doc.name, Content: doc.content }))
              : [],
        };
        await PillsDAO.addPill(this.currentWorkListId, {
          ...this.pillFormData,
          pill: {
            ...this.pillFormData.pill,
            ...pillAdditionalData,
          },
        });
        this.$router.push({ name: "myPills" });
      } catch (error) {
        this.errorMessage = this.$t(error.response.data.errorTranslationKey);
      }
    },
  },
  validations: {},
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.pill-diemension-special {
  display: flex;
  align-items: center;
  margin: 0 auto;
  max-width: 530px;
  .text {
    padding: 0 0 0 30px;
    h2 {
      font-size: 16px;
      line-height: 17px;
      color: #000000;
      margin: 0;
    }
    p {
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 0.464286px;
      color: #000000;
      margin: 10px 0;
      a {
        color: #000;
        font-weight: bold;
        text-decoration: none;
      }
    }
  }
  .icon-upload {
    position: relative;
    top: 8px;
    display: inline-block;
    width: 24px;
    height: 24px;
    background-image: url("~@/assets/icons/icon-upload.svg");

    &.grey {
      background-image: url("~@/assets/icons/icon-upload-grey.svg");
    }
  }
  .text-upload {
    display: inline;
    * {
      color: $color-black;
    }
    &.grey * {
      color: $color-medium-grey;
    }
  }
  .textarea {
    font-family: "fsalbertregular";
    border: 1px solid $color-grey;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 352px;
    height: 119px;
  }
  .error-message {
    color: $color-red !important;
    font-weight: bold;
  }
  .title {
    margin-bottom: 1.5rem !important;
  }
}
</style>
